import { render } from "./Company.vue?vue&type=template&id=6355004f&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

import "./Company.vue?vue&type=style&index=0&id=6355004f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6355004f"

export default script